import Routes from "./routes";
import GlobalStyles from "./styles/globalsStyles";

function App() {
  return (
    <>
      <GlobalStyles />
      <Routes />
    </>
  );
}

export default App;
